<template>
    <div class="bg-white rounded-xl shadow-lg p-6">
        <div class="flex items-center justify-between mb-6">
            <h3 class="text-lg font-semibold text-gray-800">Gender Distribution by Campus</h3>
        </div>
        <apexchart type="bar" :options="chartOptions" :series="chartSeries" height="350" />
    </div>
</template>

<script>
export default {
    name: "GenderDistributionByCampusChart",
    props: {
        data: {
            type: Array,
            required: true,
            default: () => [
                {
                    campus: "Abu Dhabi",
                    female: 880,
                    male: 140,
                    total: 1020
                },
                {
                    campus: "Al Ain",
                    female: 798,
                    male: 88,
                    total: 886
                },
                {
                    campus: "Ajman",
                    female: 532,
                    male: 16,
                    total: 548
                },
                {
                    campus: "AlDhafrah",
                    female: 221,
                    male: 0,
                    total: 221
                }
            ]
        }
    },
    computed: {
        chartSeries() {
            return [
                {
                    name: 'Female',
                    data: this.data.map(item => item.female)
                },
                {
                    name: 'Male',
                    data: this.data.map(item => item.male)
                }
            ];
        },
        chartOptions() {
            return {
                chart: {
                    type: 'bar',
                    stacked: true,
                    toolbar: {
                        show: false
                    },
                    animations: {
                        enabled: true,
                        easing: 'easeinout',
                        speed: 800,
                        animateGradually: {
                            enabled: true,
                            delay: 150
                        },
                        dynamicAnimation: {
                            enabled: true,
                            speed: 350
                        }
                    }
                },
                plotOptions: {
                    bar: {
                        horizontal: true,
                        barHeight: '70%',
                        dataLabels: {
                            position: 'center',
                            total: {
                                enabled: true,
                                offsetX: 0,
                                style: {
                                    fontSize: '13px',
                                    fontWeight: 900
                                }
                            }
                        }
                    }
                },
                dataLabels: {
                    enabled: true,
                    formatter: function (val) {
                        // Only show labels for non-zero values
                        if (val > 0) {
                            return val.toLocaleString();
                        }
                        return '';
                    },
                    style: {
                        fontSize: '12px',
                        fontWeight: 'bold',
                        colors: ['#ffffff']
                    }
                },
                stroke: {
                    show: true,
                    width: 2,
                    colors: ['transparent']
                },
                xaxis: {
                    categories: this.data.map(item => item.campus),
                    labels: {
                        style: {
                            fontSize: '13px',
                            fontWeight: '600',
                            colors: '#374151'
                        }
                    },
                    title: {
                        text: 'Number of Students',
                        style: {
                            fontSize: '14px',
                            fontWeight: '600',
                            color: '#374151'
                        }
                    },
                    max: 1100
                },
                yaxis: {
                    labels: {
                        style: {
                            fontSize: '13px',
                            fontWeight: '600',
                            colors: '#374151'
                        }
                    }
                },
                colors: ['#ec4899', '#3b82f6'], // Pink for Female, Blue for Male
                fill: {
                    type: 'solid',
                    opacity: 1
                },
                grid: {
                    borderColor: '#e5e7eb',
                    strokeDashArray: 4,
                    xaxis: {
                        lines: {
                            show: true
                        }
                    },
                    yaxis: {
                        lines: {
                            show: false
                        }
                    }
                },
                tooltip: {
                    y: {
                        formatter: function (val) {
                            return val.toLocaleString() + ' students';
                        }
                    },
                    theme: 'light',
                    style: {
                        fontSize: '12px'
                    }
                },
                legend: {
                    position: 'top',
                    horizontalAlign: 'right',
                    labels: {
                        colors: '#374151',
                        useSeriesColors: false
                    },
                    markers: {
                        width: 12,
                        height: 12,
                        radius: 6
                    }
                },
                responsive: [
                    {
                        breakpoint: 768,
                        options: {
                            plotOptions: {
                                bar: {
                                    barHeight: '60%'
                                }
                            },
                            dataLabels: {
                                fontSize: '11px'
                            },
                            xaxis: {
                                labels: {
                                    fontSize: '12px'
                                }
                            },
                            legend: {
                                position: 'top',
                                horizontalAlign: 'center'
                            }
                        }
                    }
                ]
            };
        }
    }
};
</script>

<style scoped>
/* Component-specific styles can be added here */
</style>